
import { DefaultState, Filters, RoomStatuses } from 'store/types';

export const READ_RESERVATIONS_DATA_REQUEST = 'READ_RESERVATIONS_DATA_REQUEST';
export const READ_RESERVATIONS_DATA_SUCCESS = 'READ_RESERVATIONS_DATA_SUCCESS';
export const READ_RESERVATIONS_DATA_FAILURE = 'READ_RESERVATIONS_DATA_FAILURE';

export interface ReservationsParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
};

export interface ReservationsRow {
  occupancy: number;
  reservationId: string;
  id: string;
  corporateClientName: string;
  lodgingOptionName: string;
  lodgingOptionLocation: string | null;
  lodgingOptionId: string;
  fromDate: string;
  toDate: string;
  bookingUserFriendlyId: number | null;
  percentageBooked: number;
  status: RoomStatuses;
  notesCount: number;
  totalNumberOfNights: number;
  totalReservationAmount: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
};

export interface ReservationsMassActionsData {
  id: string;
  status: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
}

export interface ReservationsData {
  rows: ReservationsRow[];
  totalCount: number;
};

export type ReadReservationsState = DefaultState & {
  contents?: ReservationsData;
};

interface ReadReservationsDataRequest {
  type: typeof READ_RESERVATIONS_DATA_REQUEST;
};

interface ReadReservationsDataSuccess {
  type: typeof READ_RESERVATIONS_DATA_SUCCESS,
  contents: ReservationsData;
}

interface ReadReservationsDataFailure {
  type: typeof READ_RESERVATIONS_DATA_FAILURE;
}

export type ReservationsActionTypes = ReadReservationsDataRequest | ReadReservationsDataSuccess | ReadReservationsDataFailure;